import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import SectionActions from './SectionActions';
import PrintHeader from './PrintHeader';
import {
  ShieldCheck, CheckCircle2, AlertTriangle, Plus, Loader2, Trash2
} from 'lucide-react';
import { Checkbox } from './ui/checkbox';
import { Progress } from './ui/progress';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';

const Sicurezza = () => {
  const [checklist, setChecklist] = useState([]);
  const [filterCat, setFilterCat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [newItem, setNewItem] = useState({ title: '', description: '', category: 'DPI' });
  const pageRef = useRef(null);

  const loadData = async () => {
    try { setChecklist(await api.getChecklist()); } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadData(); }, []);

  const categories = [...new Set(checklist.map(c => c.category))];
  const completed = checklist.filter(c => c.completed).length;
  const total = checklist.length;
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

  const toggleItem = async (id) => {
    try { await api.toggleChecklistItem(id); loadData(); } catch (e) { console.error(e); }
  };

  const deleteItem = async (id) => {
    try { await api.deleteChecklistItem(id); loadData(); } catch (e) { console.error(e); }
  };

  const handleAdd = async () => {
    if (!newItem.title) return;
    try {
      await api.createChecklistItem(newItem);
      setNewItem({ title: '', description: '', category: 'DPI' });
      setShowAdd(false);
      loadData();
    } catch (e) { console.error(e); }
  };

  const filtered = filterCat ? checklist.filter(c => c.category === filterCat) : checklist;

  if (loading) return <div className="page-container"><div className="loading-center"><Loader2 size={32} className="spin" /></div></div>;

  return (
    <div className="page-container" ref={pageRef}>
      <PrintHeader title="Sicurezza Cantiere" subtitle="Checklist sicurezza e conformità" />
      <div className="page-header">
        <div className="header-left">
          <h1 className="page-title">Sicurezza Cantiere</h1>
          <p className="page-subtitle">Checklist sicurezza e conformità normativa</p>
        </div>
        <div className="header-right">
          <SectionActions sectionTitle="Sicurezza Cantiere" contentRef={pageRef} />
          <Dialog open={showAdd} onOpenChange={setShowAdd}>
            <DialogTrigger asChild>
              <button className="header-action-btn"><Plus size={16} /><span>Nuovo Controllo</span></button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Nuovo Controllo Sicurezza</DialogTitle></DialogHeader>
              <div className="form-fields">
                <div className="form-field"><Label>Titolo</Label><Input value={newItem.title} onChange={e => setNewItem({...newItem, title: e.target.value})} placeholder="Es: Verifica estintori" /></div>
                <div className="form-field"><Label>Descrizione</Label><Input value={newItem.description} onChange={e => setNewItem({...newItem, description: e.target.value})} placeholder="Descrizione del controllo" /></div>
                <div className="form-field"><Label>Categoria</Label><Input value={newItem.category} onChange={e => setNewItem({...newItem, category: e.target.value})} placeholder="DPI, Strutture, Emergenze..." /></div>
                <button className="form-submit" onClick={handleAdd}>Aggiungi Controllo</button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="safety-progress-card">
        <div className="safety-progress-header">
          <ShieldCheck size={24} color="#22c55e" />
          <div><h3>Conformità Sicurezza</h3><p>{completed} di {total} controlli completati</p></div>
          <span className="safety-percent" style={{ color: percent >= 70 ? '#22c55e' : '#f59e0b' }}>{percent}%</span>
        </div>
        <Progress value={percent} className="safety-bar" />
      </div>

      <div className="safety-filters">
        <button className={`filter-chip ${!filterCat ? 'filter-chip-active' : ''}`} onClick={() => setFilterCat(null)}>Tutti ({total})</button>
        {categories.map(cat => (
          <button key={cat} className={`filter-chip ${filterCat === cat ? 'filter-chip-active' : ''}`} onClick={() => setFilterCat(filterCat === cat ? null : cat)}>{cat} ({checklist.filter(c => c.category === cat).length})</button>
        ))}
      </div>

      <div className="checklist-grid">
        {filtered.map((item) => (
          <div key={item.id} className={`checklist-item ${item.completed ? 'checklist-done' : 'checklist-pending'}`}>
            <div className="checklist-check" onClick={() => toggleItem(item.id)}><Checkbox checked={item.completed} /></div>
            <div className="checklist-content" onClick={() => toggleItem(item.id)}>
              <h4 className={item.completed ? 'line-through' : ''}>{item.title}</h4>
              <p>{item.description}</p>
              <span className="checklist-category">{item.category}</span>
            </div>
            <div className="checklist-actions-col">
              {item.completed ? <CheckCircle2 size={20} color="#22c55e" /> : <AlertTriangle size={20} color="#f59e0b" />}
              <button className="delete-icon-btn" onClick={() => deleteItem(item.id)}><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sicurezza;
